import { render, staticRenderFns } from "./UserFilter.vue?vue&type=template&id=35b4dc88&"
import script from "./UserFilter.vue?vue&type=script&lang=js&"
export * from "./UserFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/staging.clcp.cliquedomains.com/web/app/themes/clc-portal/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('35b4dc88')) {
      api.createRecord('35b4dc88', component.options)
    } else {
      api.reload('35b4dc88', component.options)
    }
    module.hot.accept("./UserFilter.vue?vue&type=template&id=35b4dc88&", function () {
      api.rerender('35b4dc88', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/vue/Page/Directory/UserFilter.vue"
export default component.exports